import { api } from "./api";

// Shared /public/stats loader: one request per 60 s for every component on the page.
const TTL_MS = 60_000;
let cache = { promise: null, at: 0 };

export function getPublicStats() {
  if (cache.promise && Date.now() - cache.at < TTL_MS) return cache.promise;
  const promise = api.get("/public/stats").catch((e) => {
    if (cache.promise === promise) cache = { promise: null, at: 0 };
    throw e;
  });
  cache = { promise, at: Date.now() };
  return promise;
}
